import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=51a8d876&scoped=true&"
import script from "./Alert.js?vue&type=script&lang=js&"
export * from "./Alert.js?vue&type=script&lang=js&"
import style0 from "./Alert.scss?vue&type=style&index=0&id=51a8d876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a8d876",
  null
  
)

export default component.exports